// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"8278b5cd","223":"37a3e595","453":"0804c4bb"}[chunkId] + ".chunk.js";
};